import { CheckCircle2, Plane, Car } from "lucide-react";
import { solutions } from "@/content";
import { Reveal, Overline } from "@/components/site/Reveal";
import { LiveDemand } from "@/components/site/LiveDemand";

export const Solution = () => (
  <section id="solution" data-testid="solution-section" className="relative py-28 bg-surface/40 border-t border-white/5">
    <div className="mx-auto max-w-7xl px-6 grid lg:grid-cols-2 gap-16 items-center">
      <Reveal>
        <LiveDemand />
      </Reveal>

      <div>
        <Reveal>
          <Overline>Our Solution</Overline>
          <h2 className="mt-4 font-heading font-extrabold text-4xl sm:text-5xl tracking-tight">
            A geo-dynamic <span className="text-gradient">intelligence layer</span> for parking.
          </h2>
          <p className="mt-5 text-lg text-white/70">
            GeoDyn adds smart, real-time pricing on top of your existing systems, with dynamic pricing for parking,
            the way airlines and ride-hailing already price demand.
          </p>
        </Reveal>

        <div className="mt-8 space-y-3">
          {solutions.map((s, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <div className="group flex items-start gap-4 rounded-xl border border-white/10 bg-ink/60 p-5 hover:border-brand-green/50 hover:-translate-y-0.5 transition-transform">
                <CheckCircle2 className="h-5 w-5 text-brand-green shrink-0 mt-0.5" />
                <span className="text-white/80">{s}</span>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3 rounded-xl border border-brand-cyan/20 bg-brand-cyan/[0.04] p-6">
            <div className="flex items-center gap-3 font-heading font-bold text-xl">
              <Plane className="h-6 w-6 text-brand-cyan" /> Like airlines.
            </div>
            <div className="flex items-center gap-3 font-heading font-bold text-xl">
              <Car className="h-6 w-6 text-brand-green" /> Like Uber.
            </div>
            <span className="text-white/60">Dynamic pricing, applied to the curb.</span>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
